export const formFields = {
  email: 'email',
  password: 'password',
  confirmPassword: 'confirmPassword',
}
